








































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import ModalAddKamar from "@/components/modal/ModalAddKamar.vue";
import ModalAddPasien from "@/components/modal/ModalAddPasien.vue";
import ModalMutasiPasien from "@/components/modal/ModalMutasiPasien.vue";
import { userModule } from "@/store/modules/user";
import UnitAutoComplete from "@/components/UnitAutoComplete.vue";
import { storeBed } from "@/store/modules/bed";
import { storeReferensi } from "@/store/modules/referensi";
import { appModule } from "@/store/modules/app";
import ModalKonfirmasi from "@/components/modal/ModalKonfirmasi.vue";
import ModalEditKamar from "@/components/modal/ModalEditKamar.vue";
import ModalListBooking from "@/components/modal/ModalListBooking.vue";
import ModalRekapBed from "@/components/modal/ModalRekapBed.vue";
import ModalLogin from "@/components/modal/ModalLogin.vue";
import DataBed from "@/services/DataBed";
import ModalAlert from "@/components/modal/ModalAlert.vue";
import moment from "moment";

@Component({
  components: {
    UnitAutoComplete,
    ModalAddKamar,
    ModalAddPasien,
    ModalMutasiPasien,
    ModalKonfirmasi,
    ModalEditKamar,
    ModalListBooking,
    ModalLogin,
    ModalAlert,
    ModalRekapBed,
  },
})
export default class Info extends Vue {
  // search = "";
  // trans = {};
  // barang = {};
  // kd = "";
  // modalTambahBarang = false;
  // modalTambahJenis = false;
  // modalTransaksi = false;
  // modalDetailTransaksi = false;
  // modalRiwayatTransaksi = false;
  // modalLokasi = false;
  // created() {
  //   storeDataMaster.actStock();
  //   storeDataMaster.actJenis();
  //   // this.timer = setInterval(this.callFeedback, 60000);
  // }
  dtBed = {};
  modalLogin = false;
  modalAddKamar = false;
  modalAddPasien = false;
  modalMutasiPasien = false;
  itemRow = {};
  modalOpenKonfirmasi = false;
  modalKonfirmasiBed = false;
  modalEditKamar = false;
  modalListBooking = false;
  modalRekapBed = false;
  msgConfirm = "";
  timer: number;
  rusak = 0;
  Kosong = 0;
  isi = 0;
  maintenance = 0;
  listBed = [];

  get headers() {
    const head = [
      {
        text: "NOMOR KAMAR/TT",
        value: "kamar",
        width: "10vh",
        align: "center",
      },
      {
        text: "KELAS",
        value: "kelas.nama",
        width: "15vh",
        align: "center",
      },
      {
        text: "STATUS",
        value: "status",
        width: "20vh",
        align: "center",
      },
      {
        text: "DATA PASIEN",
        value: "pasien",
        align: "left",
      },
      {
        text: "DIAGNOSA MASUK",
        value: "diagnosa",
        align: "left",
        width: "40vh",
      },
      {
        text: "CATATAN PASIEN",
        value: "catatan",
        align: "left",
        width: "40vh",
      },
    ];
    return head;
  }

  unit = { id: "50", nama: "WISNU (ICU COVID)" };
  // listBed = [];

  mounted() {
    this.getBed();
    this.timer = setInterval(this.getBed, 600000);
  }

  get listBedAll() {
    return storeBed.bangsal;
  }

  get listStatus() {
    return storeReferensi.status;
  }

  get loading() {
    return storeBed.loadingBangsal;
  }

  get showAlert() {
    return appModule.alert;
  }

  get errItem() {
    return {
      errorMsg: appModule.alertMessage,
      errorIcon: "mdi-alert-circle-outline",
    };
  }

  get bottomSnackbar() {
    return appModule.snackbar;
  }

  get bottomSnackbarText() {
    return appModule.notice;
  }

  get alertSnackbar() {
    return appModule.snackbaralert;
  }
  set alertSnackbar(val) {
    appModule.setSnackbaralert(val);
  }

  get alertSnackbarText() {
    return appModule.noticealert;
  }

  setUnit(val) {
    this.unit = val;
  }

  getBed() {
    storeBed.actBangsalByUnit(this.unit.id);
  }

  login() {
    this.modalLogin = true;
  }
  @Watch("unit")
  watchUnit(val) {
    this.unit = val;
    storeBed.actBangsalByUnit(val.id);
  }
  @Watch("listBedAll")
  watchListBed(val) {
    this.isi = val.filter(
      (val) => val.status.id == 1 && val.gabung == "0"
    ).length;
    this.Kosong = val.filter(
      (val) => val.status.id == 2 && val.gabung == "0"
    ).length;
    this.rusak = val.filter(
      (val) => val.status.id == 4 && val.gabung == "0"
    ).length;
    this.maintenance = val.filter(
      (val) => val.status.id == 3 && val.gabung == "0"
    ).length;
    this.listBed = this.listBedAll;
  }

  ttIsi() {
    this.listBed = this.listBedAll.filter((val) => val.status.id == 1);
  }
  ttKosong() {
    this.listBed = this.listBedAll.filter((val) => val.status.id == 2);
  }
  ttRusak() {
    this.listBed = this.listBedAll.filter((val) => val.status.id == 4);
  }
  ttMaintenance() {
    this.listBed = this.listBedAll.filter((val) => val.status.id == 3);
  }
  // test() {
  // alert("aa");
  // appModule.sendErrorAlert("aaa");
  // appModule.NoticeDelay("Berhasil Menambahkan Kamar");
  // appModule.NoticeDelayAlert("eror");
  // }

  getFormatDateTime(date) {
    return date
      ? moment(date, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm:ss")
      : "";
  }

  ListBooking() {
    this.modalListBooking = true;
  }

  rekapBed() {
    storeBed.actRekapBed();
    this.modalRekapBed = true;
  }
  allPasien() {
    const routeData = this.$router.resolve({ path: "/informasi" });
    window.open(routeData.href, "_blank");
  }
}
